import { get } from 'lodash';
import { AxiosClient } from 'src/configs/axios/axios';

const CATEGORY_API = {
  listCategoryAPI: async (params: Category.GetCategoryParams) => {
    const response = await new AxiosClient().get('/categories', { params })
    return get(response, 'data', null)
  },
  // createCategoryAPI: async (params: any) => {
  //   const response = await new AxiosClient().post('/categories', params)
  //   const data = get(response, 'data', null)
  //   return data
  // },
  // updateCategoryAPI: async (params: any) => {
  //   const response = await new AxiosClient().put(
  //     '/categories/' + params.id, params)
  //   const data = get(response, 'data', null)
  //   return data
  // },
  // deleteCategoryAPI: async (id: any) => {
  //   const response = await new AxiosClient().delete('/categories/' + id)
  //   const data = get(response, 'data', null)
  //   return data
  // },
}

export default CATEGORY_API
